import {ReactNode} from 'react';
import Box from '@mui/material/Box';

/**
 * HOC used around each private screen.
 */
export const ContentPage = (props: {children: ReactNode; fullWidth?: boolean}) => {
  // Default result
  return (
    <Box sx={{display: 'flex', justifyContent: 'center', width: '100%', minWidth: 0}}>
      <Box sx={{width: '100%', minWidth: 0, maxWidth: props.fullWidth ? '100%' : '1024px'}}>
        {props.children}
      </Box>
    </Box>
  );
};
